// Import Packages
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { CheckIfFlowUpdated } from '../../../helpers/helper';
import 'prismjs/components/prism-python';

// Import Material UI
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { IconButton, TextField, InputBase } from '@material-ui/core';
import FilterCenterFocusIcon from '@material-ui/icons/FilterCenterFocus';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';

// Import Pages
import { VariableModal } from '../VariableModal/VariableModal';
import {
    lastFocusField,
    inputRefresh,
    showObjectExplorerIcon,
    activeAutom,
    selectedField,
    initialActions, saveAvailable, changedFields
} from "../../../recoil-store/recoil-state";
import 'react-quill/dist/quill.snow.css';
import CommonModal from '../CommonModal/CommonModal';

// Import Icons
import MateDriveIcon from '../../../assets/icons/moduleIcons/mate-drive-link-icon.svg'


// Import CSS
import '../TextInput/TextInput.css'
import './NewPasswordInput.css'
import 'react-resizable/css/styles.css';

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       inputName - string
 * @param       variables - object variable list
 * @param       multiline - boolean
 * @param       onBlur - function
 * @param       include - array
 * @param       disabled - boolean
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       isRequired - boolean
 * @param       isCredentialPickerValue - boolean
 * @param       inputMode - string
 * @returns     Component
 * @author      Emirhan Bilal YEŞİL
 */

const styles = {
    handle: {
        color: '#000',
        fontWeight: 'bold',
        direction: 'ltr',
        unicodeBidi: 'bidi-override'
    }
};

const HANDLE_REGEX = /(##\w*(\[+\w+\]+)*##)/g;

function handleStrategy(contentBlock, callback) {
    findWithRegex(HANDLE_REGEX, contentBlock, callback);
}

function findWithRegex(regex, contentBlock, callback) {
    const text = contentBlock.getText();
    let matchArr, start;
    while ((matchArr = regex.exec(text)) !== null) {
        start = matchArr.index;
        callback(start, start + matchArr[0].length);
    }
}

// const HandleSpan = (props) => {
//     return (
//         <span style={styles.handle} data-offset-key={props.offsetKey}>
//             {props.children}
//         </span>
//     );
// };

function PasswordInput({
    action,
    inputName,
    variables,
    multiline,
    include,
    recorder,
    disabled,
    isRequired,
    setOpenVariable,
    inputMode = 'text',
    isVariableAdd = true,
    refresh = false,
    defaultValue = undefined,
    isCredentialPickerValue,
    setField,
    validation,
    fieldType,
    displayName,
    type,
    hideRequired,
    action_id,
    autom_id,
    fieldName,
    subInputName,
    ignoreSave,
    outLabel,
    showOpenModal,
    onfocus,
    outNewValue,
    outOnChange,
}) {
    const [commonModal, setCommonModal] = useState(false);
    const [inputRefreshGlobal] = useRecoilState(inputRefresh);
    const [showOEIcon, setShowOEIcon] = useRecoilState(showObjectExplorerIcon);
    const [openDrive, setOpenDrive] = useState(false);
    // const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const [richEditorState, setRichEditorState] = useState({ editorHtml: '', theme: 'snow' })
    // const [editorWidth, setEditorWidth] = useState("100%");
    // const [editorHeight, setEditorHeight] = useState(250);
    const [inputValue, setInputValue] = useState("");
    const [inputType, setInputType] = useState("text");
    const [selectedFieldValue, setSelectedFieldValue] = useRecoilState(selectedField);
    const [focusField, setFocusField] = useRecoilState(lastFocusField);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const setChangeFields = useSetRecoilState(changedFields);
    const changedFieldsState = useRecoilValue(changedFields);
    const [open, setOpen] = useState(false);
    // const [showObjectExporer, setShowObjectExplorer] = useState(false);

    const [dropdownValue, setDropdownValue] = useState({});
    const [indexValue, setIndexValue] = useState(0);
    const { t } = useTranslation();
    // const editor = useRef(false);
    const validate = useRef(false);



    useEffect(() => {
        if (action?.fields && !action.fields[inputName]) {
            action.fields[inputName] = { isRequired, value: defaultValue ? defaultValue : '' };

            if (displayName) {
                action.fields[inputName].conditions = [];
            }
            if (setField) {
                // setField(inputName, action.fields[inputName]);
            }
        }
        if (action.fields[inputName].value) {
            if (typeof (action.fields[inputName].value) !== "string") return
            const value = action.fields[inputName].value
            setInputValue(value);
            const isInsideDoubleHash = /##[^#]+##/.test(value);
            setInputType(isInsideDoubleHash || !value ? "text" : "password");
        }
        action.fields[inputName].is_password = true;

        if (type === "html") {
            setRichEditorState({ editorHtml: action.fields[inputName].value, theme: 'snow' })
        }
    }, [action, inputName, disabled, refresh, inputRefreshGlobal]);

    useEffect(() => {
        let actionId;
        if (action.id) {
            actionId = action.id;
        } else if (action_id) {
            actionId = action_id;
        }
        if (outNewValue?.isOk && (outNewValue.value || outNewValue.value === "") && action?.fields && action.fields[inputName]) {
            action.fields[inputName].value = outNewValue.value
            const field = initialActionsData[actionId]?.fields[inputName];
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated(inputName, action, oldValue, outNewValue.value, setSaveAvailable, setChangeFields, changedFieldsState);

            setInputValue(outNewValue.value);
        }
    }, [outNewValue?.value])

    useEffect(() => {
        let actionId;
        if (action.id) {
            actionId = action.id;
        } else if (action_id) {
            actionId = action_id;
        }
        action.fields[inputName].value = inputValue
        const field = initialActionsData[actionId]?.fields[inputName];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated(inputName, action, oldValue, inputValue, setSaveAvailable, setChangeFields, changedFieldsState);
    }, [inputValue])

    useEffect(() => {
        if (selectedFieldValue.path.length && focusField.inputName && focusField.inputName === inputName) {

            const valueEndIndex = selectedFieldValue.path.indexOf('[')
            let firstValue;
            let secondValue;
            if (valueEndIndex !== -1) {
                firstValue = selectedFieldValue.path.substring(2, valueEndIndex)
                secondValue = selectedFieldValue.path.substring(valueEndIndex)
            } else {
                firstValue = selectedFieldValue.path.substring(2, selectedFieldValue.path.length - 2)
                secondValue = selectedFieldValue.path.substring(selectedFieldValue.path.length - 2);
            }
            let v;
            if (selectedFieldValue.key === '') {
                v = `##${firstValue}${secondValue}`;
            } else {
                v = `##${selectedFieldValue.key}[${firstValue}]${secondValue}`;
            }
            setInputValue(inputValue + v);
            setSelectedFieldValue({
                key: '',
                name: '',
                type: '',
                path: []
            });
        }
    }, [selectedFieldValue])

    const getValue = () => {
        if (action) {
            if (action.fields && inputName) {
                return action.fields[inputName]?.value?.length ? action.fields[inputName].value : '';
            } else if (inputName || inputName >= 0) {
                return action[inputName]?.value ? action[inputName].value : '';
            } else {
                return action.value ? action.value : '';
            }
        } else {
            return '';
        }
    };

    // const checkValidate = async (validateConfiguration) => {
    //     let isValidate = true;

    //     if (validateConfiguration.length) {
    //         validateConfiguration.forEach(item => {
    //             switch (item.type) {
    //                 case "length":
    //                     const newValue = inputValue.length;
    //                     if (item.validation.operator === "lt") {
    //                         isValidate = newValue < item.validation.value;
    //                         break;
    //                     } else if (item.validation.operator === "gt") {
    //                         isValidate = newValue > item.validation.value;
    //                         break;
    //                     } else {
    //                         isValidate = newValue === item.validation.value;
    //                         break;
    //                     }
    //                 default:
    //                     isValidate = true;
    //                     break;
    //             }
    //         })
    //     }

    //     return isValidate;
    // }

    // c => conditions
    const setValue = (v, c) => {
        if (action.fields && inputName) {
            action.fields[inputName] = { ...action.fields[inputName], value: v, isRequired };
            if (setField) {
                setField(inputName, action.fields[inputName]);
            }
        } else if (inputName || inputName >= 0) {
            action[inputName] = {
                ...action[inputName],
                value: v,
                isRequired
            };
            if (setField) {
                setField(inputName, action[inputName]);
            }
        } else if (action) {
            action.value = v;
        }
    };

    const onChange = async (e) => {
        const value = e.target.value
        const isInsideDoubleHash = /##[^#]+##/.test(value);
        if (isInsideDoubleHash || (inputType === "text" && value && e?.target.defaultValue !== "")) {
            const regex = /##[^#]+##/g;
            const splits = value.split(regex);
            let inculudeText
            if (splits.length) {
                for (let index = 0; index < splits.length; index++) {
                    if (splits[index].trim() !== "") {
                        inculudeText = true;
                    }

                }
            }
            if (inculudeText) return
        }


        let actionId;
        if (action.id) {
            actionId = action.id;
        } else if (action_id) {
            actionId = action_id;
        }
        if (!ignoreSave && actionId) {
            const newValue = value;
            const field = initialActionsData[actionId]?.fields[inputName];
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
            if (outOnChange) {
                outOnChange(newValue)
            }
        }
        setInputType(isInsideDoubleHash || !value ? "text" : "password");
        setValue(value);
        setInputValue(value);
    };
    const onBlur = async (e) => {
        const dummyInput = document.createElement('input');
        document.body.appendChild(dummyInput);
        dummyInput.focus();
        document.body.removeChild(dummyInput);
    };

    const handleAddClick = async () => {
        if (inputType === "password") {
            setOpen(false);
            return
        }
        let newValue;
        // const field = initialActionsData[dropdownValue.id]?.fields[inputName];
        // const oldValue = !field ? undefined : field?.value;

        if (dropdownValue.type === 'array' && indexValue !== null) {
            newValue = '##' + dropdownValue.name + '[' + indexValue + ']##';
            setInputValue(inputValue + ('##' + dropdownValue.name + '[' + indexValue + ']##'));
        } else {
            newValue = '##' + dropdownValue.name + '##';
            setInputValue(inputValue + ('##' + dropdownValue.name + '##'));
        }
        // CheckIfFlowUpdated(inputName, dropdownValue, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        setOpen(false);
    };

    // const insertText = (text, editorState) => {
    //     const currentContent = editorState.getCurrentContent(), currentSelection = editorState.getSelection();
    //     const newContent = Modifier.replaceText(currentContent, currentSelection, text);
    //     const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
    //     return EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());
    // };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const requireValidate = (!getValue() && isRequired) && !isCredentialPickerValue;
    const errorValidate = inputMode === 'text' ? requireValidate : requireValidate || !validate.current;

    // const handleOnFocus = () => {
    //     setFocusField({
    //         inputName,
    //         type: include && include.length ? include[0] : '',
    //         //is_sys_field: !action.fields
    //     });
    // }

    // const handleShowObjectExplorer = () => {
    //     if (showOEIcon) {
    //         setShowOEIcon(false);
    //     }
    //     setShowObjectExplorer(true);
    // }

    // const cancelObjectExplorer = () => {
    //     setShowOEIcon(true);
    //     setShowObjectExplorer(false);
    // }

    // const saveObjectExplorer = (f, conditionExist) => {
    //     if (action.fields && inputName) {
    //         action.fields[inputName].functions = f;
    //     }

    //     //     action.fields[inputName].conditions = c;
    //     //    // const anyActionHasCondition = c.some(function (a) { return a.length });
    //     if (!conditionExist) {
    //         if (action.conditions) {
    //             const fieldIndex = action.conditions.indexOf(inputName);
    //             action.conditions.splice(fieldIndex, 1);
    //         }
    //     } else if (action.conditions) {
    //         if (!action.conditions.find(x => x === inputName)) {
    //             action.conditions.push(inputName);
    //         }
    //     } else {
    //         action.conditions = [inputName];
    //     }


    //     //setValue(data.value, data.conditions)
    //     // EditorState.set(editorState, data.value);
    //     //setInputValue(createState(data.value)); // insertText(data.value, state.editorState)
    //     setShowOEIcon(true);
    //     setShowObjectExplorer(false);
    //     let copyItems = JSON.parse(JSON.stringify(automDetail.items))
    //     findAndUpdateItem(copyItems)
    //     setAutomDetail({
    //         ...automDetail,
    //         items: copyItems
    //     })
    // }

    const findAndUpdateItem = (items) => {
        items.forEach(item => {
            if (item.item_id === action.item_id) {
                item.fields = JSON.parse(JSON.stringify(action.fields))
                item.conditions = JSON.parse(JSON.stringify(action.conditions))
            } else if (item.children) {
                findAndUpdateItem(item.children)
            }
        })
    }

    // const saveNewValue = (v, selectedVariableName) => {

    //     if (action.fields && inputName) {
    //         action.fields[inputName] = { ...action.fields[inputName], value: v, selectedVariableName, isRequired };
    //         if (setField) {
    //             setField(inputName, action.fields[inputName]);
    //         }
    //     }
    //     setInputValue(v);
    //     setShowOEIcon(true);
    //     setShowObjectExplorer(false);
    // }

    const openCommonModal = () => {
        setCommonModal(true);
    }

    const closeCommonModal = () => {
        let newValue = inputValue;
        let actionId;
        if (action.id) {
            actionId = action.id;
        } else if (action_id) {
            actionId = action_id;
        }
        const field = initialActionsData[actionId]?.fields[inputName];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        setValue(newValue);
        setCommonModal(false);
    }

    const saveCommonModal = () => {
        const newValue = getValue();
        let actionId;
        if (action.id) {
            actionId = action.id;
        } else if (action_id) {
            actionId = action_id;
        }
        const field = initialActionsData[actionId]?.fields[inputName];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        setInputValue(newValue);
        setCommonModal(false);
    }

    const handleShowDrive = () => {
        setOpenDrive(true);
    }

    const ContentToModal = () => {
        return (
            <PasswordInput showOpenModal={false} type="html" action={action} inputName="body" variables={variables} setOpenVariable={setOpenVariable}
                multiline fieldType="string" displayName={t(outLabel + 'BODY')} />
        )
    }

    // const handleResize = (event, { size }) => {
    //     if (!showOpenModal && size.height > 255) {
    //         setEditorWidth(size.width);
    //         setEditorHeight(size.height);
    //     }
    // };
    // const handleKeyDown = (event) => {
    //    
    //     if (inputType === "text" && event.key !== "Backspace") {
    //         setInputType("password")
    //         if (inputValue !== "") {
    //             event.preventDefault();
    //         }
    //     }
    // };

    return (
        <>
            {commonModal && (
                // <CommonModal closeModal={closeCommonModal} content={<ContentToModal />} />
                <CommonModal save={saveCommonModal} closeModal={closeCommonModal} content={<ContentToModal />} />
            )}
            {requireValidate && inputMode === 'text' && !hideRequired &&
                <small style={{ color: '#D75E5E' }}>&nbsp; {t('FLOW-MESSAGES.LIBRARY.GENERAL.REQUIRED')}</small>}
            <div className='new-text-input-container'>
                <div className={`editable${multiline ? ' multiline' : ''} ${(showOEIcon && fieldType && (fieldType.includes('string') || inputValue))
                    && ["filePath", "folderPath"].includes(inputName) && autom_id && "small-editable"}`}
                    style={{
                        minHeight: multiline && 100,
                        border: errorValidate && '1px solid #E6E6E6',
                        backgroundColor: "#FCFCFC"
                    }}
                    onClick={() => { onfocus && onfocus() }}
                >
                    <InputBase
                        className={`password-input-base ${inputType === "text" && 'color-black'}`}
                        name='field_password'
                        fullWidth
                        autoComplete={false}
                        type={inputType}
                        defaultValue="Naked input"
                        onChange={onChange}
                        onBlur={onBlur}
                        // onKeyDown={(e) => handleKeyDown(e)}
                        value={inputValue}
                        inputProps={{ 'aria-label': 'naked' }}
                    />
                    {
                        ["filePath", "folderPath"].includes(inputName) && autom_id && (
                            <IconButton className="mate-drive-button" style={{ position: 'absolute' }} onClick={handleShowDrive}>
                                <img src={MateDriveIcon} />
                            </IconButton>
                        )
                    }
                </div>
                {/* {(showOEIcon && fieldType && (fieldType.includes('string') || inputValue)) && ["filePath", "folderPath"].includes(inputName) && autom_id &&
                    <IconButton className="object-explorer-button" style={{ position: 'absolute', float: 'rigth' }}
                        onClick={handleShowObjectExplorer}>
                        <FilterCenterFocusIcon style={{ paddingTop: 5, color: "#8C90A2" }} />
                    </IconButton>
                } */}
                {
                    showOpenModal && (
                        <IconButton className="expand-button" style={{ position: 'absolute' }} onClick={openCommonModal}>
                            <AspectRatioIcon style={{ paddingTop: 5, color: "#8C90A2" }} />
                        </IconButton>
                    )
                }
                {isVariableAdd &&
                    <IconButton className="add-variable-button" onClick={handleClickOpen}
                        disabled={disabled}>
                        <AddCircleOutlineIcon className="add-variable-icon" />
                    </IconButton>}
                {open && (
                    <VariableModal setOpen={setOpen} variables={variables}
                        dropdownValue={dropdownValue} setDropdownValue={setDropdownValue}
                        setOpenVariable={setOpenVariable}
                        indexValue={indexValue} setIndexValue={setIndexValue}
                        handleAddClick={handleAddClick} include={include}
                    />
                )}
            </div>
            {
                (requireValidate || !validate.current) && inputMode === 'email' &&
                <div><small style={{ color: '#D75E5E' }}><em> * Enter a valid email address.</em></small></div>
            }
            {/* {
                showObjectExporer && (
                    <ObjectExplorer
                        show={showObjectExporer} cancel={cancelObjectExplorer}
                        variables={variables} setOpenVariable={setOpenVariable}
                        field={{
                            value: inputValue, name: inputName,
                            type: fieldType, displayName,
                            selectedVariableName: action.fields && action.fields[inputName] ? action.fields[inputName].selectedVariableName : ''
                        }}
                        functions={
                            action.fields && action.fields[inputName]
                                && action.fields[inputName].functions && action.fields[inputName].functions.length
                                ? action.fields[inputName].functions : []
                        }
                        save={saveObjectExplorer}
                        saveNewValue={saveNewValue}
                    // fieldConditions={
                    //     action.fields && action.fields[inputName]
                    //         && action.fields[inputName].conditions && action.fields[inputName].conditions.length
                    //         ? action.fields[inputName].conditions : []
                    // }
                    // selectedVariable={action.fields[inputName]} saveConfiguration={() => { }}
                    //value={assignValues[configureModal.index]} variableRender={variableRender}
                    />
                )
            } */}
            {/* {openDrive && (
                <MateDrive setOpen={setOpenDrive} flowId={autom_id} from={inputName} />
            )} */}
        </>
    );
}

export { PasswordInput };
